<template>
    <article class="forum-comment">
        <ForumAvatar :name="comment.userName" />
        <div class="forum-comment__body">
            <header class="forum-comment__head">
                <p class="forum-comment__name">{{ comment.userName }}</p>
                <p class="forum-comment__date">{{ dateLabel }}</p>
            </header>
            <div class="forum-comment__text" v-html="comment.comment"></div>
        </div>
    </article>
</template>

<script>
    import ForumAvatar from './ForumAvatar.vue';

    export default {
        name: 'ForumCommentCard',
        components: { ForumAvatar },
        props: {
            comment: {
                type: Object,
                required: true,
            },
        },
        computed: {
            dateLabel() {
                if (!this.comment?.dateInsert) return '-';
                const date = new Date(this.comment.dateInsert);
                if (Number.isNaN(date.getTime())) return '-';
                return date.toLocaleDateString('pt-BR', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                });
            },
        },
    };
</script>
